<ng-container *ngIf="question">
  <ng-container *ngFor="let option of question.answerOptions">
    <div class="d-flex align-items-center mb-2">
      <ng-container *ngIf="isQuiz">
        <div class="answer-input me-2">
          <app-proforms-question-answer-options-checkbox
            [optionId]="option.id"
            [checkStatus]="option.is_correct"
            (answerClicked)="handleCheckedAnswer($event)" />
        </div>
      </ng-container>
      <div class="d-flex align-items-center custom-input-group flex-grow-1">
        <div class="form-check d-flex align-items-center me-1 mb-0 ps-1">
          <input
            [id]="'option-' + question.id + '-' + option.id"
            type="{{
              question.field_type === FieldTypes.RADIO ? 'radio' : 'checkbox'
            }}"
            [name]="
              question.field_type === FieldTypes.RADIO
                ? 'radio-' + question.id
                : 'checkbox-' + question.id
            "
            class="form-check-input"
            disabled />
        </div>
        <input
          type="text"
          class="form-control custom-input"
          [(ngModel)]="option.answer"
          (ngModelChange)="onAnswerChange(option.id, $event)" />
        <ng-template #deletePopoverContent>
          Delete this answer?
          <div class="text-end mt-2">
            <button
              type="button"
              class="btn btn-secondary btn-sm px-3 m-1"
              (click)="popover.close()">
              No
            </button>
            <button
              type="button"
              class="btn btn-primary btn-sm px-3 m-1"
              (click)="deleteAnswer(option.id); popover.close()">
              Yes
            </button>
          </div>
        </ng-template>
      </div>
      <button
        class="btn btn-delete fs-13"
        type="button"
        aria-label="Delete answer"
        #tooltip="ngbTooltip"
        (click)="tooltip.close()"
        [ngbPopover]="deletePopoverContent"
        [autoClose]="'outside'"
        ngbTooltip="Delete Answer"
        #popover="ngbPopover">
        <i class="bi bi-trash"></i>
      </button>
    </div>
  </ng-container>
  <button
    [class.quiz-spacer]="isQuiz"
    class="btn btn-add-option fw-700 fs-14 p-0 mt-2 mb-5"
    (click)="addAnswerOption()">
    + Add Option
  </button>
</ng-container>
<ng-template #preview>
  <app-proforms-question-answer-options
    [question]="question"></app-proforms-question-answer-options>
</ng-template>
